import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendInvitation, fetchSentInvitations, cancelInvitation } from '../../store/actions/invitation';
import { Button, Form, InputGroup, Badge, Table } from 'react-bootstrap';

const statusLabel = {
    pending: { text: 'Čaká', variant: 'warning' },
    accepted: { text: 'Prijatá', variant: 'success' },
    declined: { text: 'Odmietnutá', variant: 'secondary' },
};

const InviteUser = () => {
    const dispatch = useDispatch();
    const { sent } = useSelector(state => state.invitation);
    const [email, setEmail] = useState('');

    const handleCancel = (id) => {
        if (window.confirm('Naozaj chceš zrušiť túto pozvánku?')) {
            dispatch(cancelInvitation(id));
        }
    };

    useEffect(() => {
        dispatch(fetchSentInvitations());
    }, [dispatch]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;
        const result = await dispatch(sendInvitation(email));
        if (!result.error) {
            setEmail('');
            dispatch(fetchSentInvitations());
        }
    };

    return (
        <div>
            <h5 className="mb-3">Pozvať používateľa</h5>
            <Form onSubmit={handleSubmit}>
                <InputGroup className="mb-4">
                    <Form.Control
                        type="email"
                        placeholder="Email používateľa"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <Button type="submit" variant="primary" disabled={!email}>
                        Pozvať
                    </Button>
                </InputGroup>
            </Form>

            {sent.length > 0 && (
                <>
                    <h6>Odoslané pozvánky</h6>
                    <Table hover>
                        <thead>
                            <tr>
                                <th>Používateľ</th>
                                <th>Pozval</th>
                                <th>Stav</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {sent.map(inv => {
                                const s = statusLabel[inv.status];
                                return (
                                    <tr key={inv._id}>
                                        <td>
                                            {inv.userId?.name} {inv.userId?.surname}
                                            <br />
                                            <small className="text-muted">{inv.userId?.email}</small>
                                        </td>
                                        <td>{inv.invitedBy?.name} {inv.invitedBy?.surname}</td>
                                        <td><Badge bg={s.variant}>{s.text}</Badge></td>
                                        <td className="text-end">
                                            {inv.status === 'pending' && (
                                                <Button
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    onClick={() => handleCancel(inv._id)}
                                                >
                                                    Zrušiť
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </>
            )}
        </div>
    );
};

export default InviteUser;
